import { Component, OnInit, Inject } from '@angular/core';
import { CustomerPopupInput } from './customer-popup-input';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Customer } from '../../dto/customer';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatList, MatListItem, MatListItemIcon, MatListItemTitle } from '@angular/material/list';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'pcp-customer-select-popup',
    templateUrl: './customer-select-popup.component.html',
    styleUrls: ['./customer-select-popup.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FlexModule, MatFormField, MatInput, FormsModule, MatIcon, MatPrefix, NgIf, MatButton, MatIconButton, MatSuffix, MatList, NgFor, MatListItem, NgClass, ExtendedModule, MatListItemIcon, MatListItemTitle, MatDivider, MatDialogActions, MatDialogClose]
})
export class CustomerSelectPopupComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CustomerPopupInput,
    private dialogRef: MatDialogRef<CustomerSelectPopupComponent>
  ) {}

  highlightedCustomer: Customer | null = null;
  search: string | null = null;
  displayedList: Customer[] | null = null;
  ngOnInit() {
    this.displayedList = this.data.customers;
  }
  refreshList() {
    if (this.search) {
      this.displayedList = this.data.customers.filter((c) =>
        c.name.includes(this.search!)
      );
    } else {
      this.displayedList = this.data.customers;
    }
  }
  selectCustomer(customer: Customer) {
    this.dialogRef.close(customer);
  }
}
